export enum DocumentCategoryIdentifier {
  /**
   * Justificatifs
   * @type {DocumentCategoryIdentifier.receipt}
   */
  receipt = 'receipt',
  /**
   * Indemnités kilométriques
   * @type {DocumentCategoryIdentifier.mileageAllowance}
   */
  mileageAllowance = 'mileage_allowance',
  /**
   * Fiscal
   * @type {DocumentCategoryIdentifier.fiscal}
   */
  fiscal = 'fiscal',
  /**
   * Frais avancés
   * @type {DocumentCategoryIdentifier.advancedExpense}
   */
  advancedExpense = 'advanced_expense',
  /**
   * Notes de frais
   * @type {DocumentCategoryIdentifier.expenseReport}
   */
  expenseReport = 'expense_report',
  /**
   * Social salariés
   * @type {DocumentCategoryIdentifier.socialEmployee}
   */
  socialEmployee = 'social_employee',
  /**
   * Juridique
   * @type {DocumentCategoryIdentifier.juridical}
   */
  juridical = 'juridical',
  /**
   * Social dirigeants
   * @type {DocumentCategoryIdentifier.socialDirector}
   */
  socialDirector = 'social_director',
  /**
   * Comptes annuels
   * @type {DocumentCategoryIdentifier.annualAccount}
   */
  annualAccount = 'annual_account',
  /**
   * Bulletins de paie
   * @type {DocumentCategoryIdentifier.payslip}
   */
  payslip = 'payslip',
  /**
   * Documents permanents
   * @type {DocumentCategoryIdentifier.permanentDocument}
   */
  permanentDocument = 'permanent_document',
  /**
   * Factures de vente externes
   * @type {DocumentCategoryIdentifier.externalInvoice}
   */
  externalInvoice = 'external_invoice',
  /**
   * Autres types de documents
   * @type {DocumentCategoryIdentifier.otherDocument}
   */
  otherDocument = 'other_document',
  /**
   * Documents gérés par le comptable
   * @type {DocumentCategoryIdentifier.custom}
   */
  custom = 'custom'
}
